import { render, staticRenderFns } from "./CMAddRemindSetting.vue?vue&type=template&id=8fb98ce8&scoped=true&"
import script from "./CMAddRemindSetting.vue?vue&type=script&lang=js&"
export * from "./CMAddRemindSetting.vue?vue&type=script&lang=js&"
import style0 from "./CMAddRemindSetting.vue?vue&type=style&index=0&id=8fb98ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb98ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fb98ce8')) {
      api.createRecord('8fb98ce8', component.options)
    } else {
      api.reload('8fb98ce8', component.options)
    }
    module.hot.accept("./CMAddRemindSetting.vue?vue&type=template&id=8fb98ce8&scoped=true&", function () {
      api.rerender('8fb98ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMAddRemindSetting.vue"
export default component.exports